import { OktaAuth } from '@okta/okta-auth-js';

const redirectUriBase = window.location.origin;
const basePath = (config?.VUE_APP_BASE_PATH || '').replace(/\/$/, '');

const clientId = config.VUE_APP_OKTA_CLIENT_ID;
const oktaIssuer = config.VUE_APP_OKTA_ISSUER;
const oktaScopes = config.VUE_APP_OKTA_SCOPES;

export const authUrls = {
  loginUrl: redirectUriBase + basePath + '/login',
  logoutUrl: redirectUriBase + basePath + '/logout',
  callbackUrl: redirectUriBase + basePath + '/login/callback',
};

export const oktaAuth = new OktaAuth({
  issuer: oktaIssuer,
  clientId: clientId,
  redirectUri: authUrls.callbackUrl,
  scopes: oktaScopes.split(' '),
  logoutUrl: authUrls.logoutUrl,
  pkce: true,
  storageManager: {
    token: {
      storageType: 'sessionStorage',
    },
    cache: {
      storageType: 'sessionStorage',
    },
    transaction: {
      storageType: 'sessionStorage',
    },
  },
  tokenManager: {
    autoRenew: true,
  },
});
